import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import Dialog from '../../../../atoms/feedback/Dialog'
import { FlexColumn } from '../../../../atoms/layout/Flex'
import Button from '../../../../atoms/inputs/Button'
import { CompanyActions } from '../../../../../store/company'
import Label from '../../../../atoms/display/Label'
import { useVisitorRegistrationFormSubcontractorDeleteDialog } from '../../../../../hooks/useDialog'

export default function VisitorRegistrationFormSubcontractorDeleteDialog() {
  const { state, close } = useVisitorRegistrationFormSubcontractorDeleteDialog()
  const dispatch = useDispatch()

  const handleDelete = useCallback(() => {
    if (state) {
      dispatch(CompanyActions.deleteVisitorRegistrationFormSubcontractor({ subcontractorId: state.subcontractor.id }))
    }
  }, [dispatch, state])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="下請け情報の削除"
      actions={
        <Button type="submit" color="caution" onClick={handleDelete}>
          削除
        </Button>
      }
    >
      <FlexColumn>
        <Label text="以下の下請け情報を削除しますか？" />
        {state && (
          <FlexColumn space={0}>
            <Label text={state.subcontractor.kana} variant="caption" />
            <Label text={state.subcontractor.name} />
          </FlexColumn>
        )}
      </FlexColumn>
    </Dialog>
  )
}
